/**
 * Splits a local datetime string "YYYY-MM-DD HH:MM:SS" into its display parts.
 * No timezone conversion is applied — the time is used exactly as received.
 * Example: "2026-06-09 05:30:00" → { date: "9 Jun '26", time: "5:30 AM" }
 */
export function formatSessionParts(localDateStr) {
  const str = String(localDateStr ?? "");
  const [datePart = "", timePart = "00:00:00"] = str.split(" ");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hours, minutes] = timePart.split(":").map(Number);
  const MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const mon = MONTHS[(month ?? 1) - 1] ?? "";
  const yr = String(year ?? 0).slice(2);
  const ampm = hours >= 12 ? "PM" : "AM";
  const h12 = hours % 12 || 12;
  const mm = String(minutes).padStart(2, "0");
  return { date: `${day} ${mon} '${yr}`, time: `${h12}:${mm} ${ampm}` };
}

/** The same value as formatSessionParts, joined with the "•" separator. */
export function formatSessionDate(localDateStr) {
  const { date, time } = formatSessionParts(localDateStr);
  return `${date} • ${time}`;
}

/**
 * Returns true if now is within the join window:
 *   - up to `windowMinutes` before the session starts
 *   - up to 1 hour after the session starts
 */
export function isWithinJoinWindow(slotDateIso, windowMinutes = 15) {
  const diff = new Date(slotDateIso).getTime() - Date.now();
  return diff <= windowMinutes * 60 * 1000 && diff > -60 * 60 * 1000;
}

export const getIsTutorialStatus = (
  Role,
  isTutorialGlobal,
  isMentorSelectedTutorial,
) => {
  const isGuestMentor = localStorage.getItem("isGuestMentor") === "1";
  return Role === "admin" && isTutorialGlobal
    ? 1
    : Role === "mentor" && isMentorSelectedTutorial
      ? 1
      : isGuestMentor && isMentorSelectedTutorial
        ? 1
        : 0;
};

export function parseGradeToNumber(gradeString) {
  if (!gradeString) return null;
  if (gradeString.toLowerCase() === "kg") return 0;
  const match = gradeString.match(/\d+/);
  return match ? parseInt(match[0], 10) : null;
}